/**
 * Composable для работы с временными интервалами
 */
export function useTimeAgo() {
  /**
   * Форматирует прошедшее время с правильным склонением
   * @param {string|Date} utcDate - Дата в UTC формате
   * @returns {string} Отформатированная строка времени
   */
  const formatTimeAgo = (utcDate) => {
    const now = new Date();
    const date = new Date(utcDate);
    const diffInSeconds = Math.floor((now - date) / 1000);
    
    const intervals = {
      год: 31536000,
      месяц: 2592000,
      неделя: 604800,
      день: 86400,
      час: 3600,
      минута: 60
    };
    
    for (const [unit, seconds] of Object.entries(intervals)) {
      const interval = Math.floor(diffInSeconds / seconds);
      
      if (interval >= 1) {
        if (unit === 'день') {
          return getDayForm(interval);
        }
        return `${interval} ${getUnitForm(interval, unit)} назад`;
      }
    }
    
    return 'только что';
  };

  // Вспомогательные функции
  const getUnitForm = (n, unit) => {
    const forms = {
      год: ['год', 'года', 'лет'],
      месяц: ['месяц', 'месяца', 'месяцев'],
      неделя: ['неделя', 'недели', 'недель'],
      день: ['день', 'дня', 'дней'],
      час: ['час', 'часа', 'часов'],
      минута: ['минута', 'минуты', 'минут']
    };
    
    n = Math.abs(n) % 100;
    const n1 = n % 10;
    
    if (n > 10 && n < 20) return forms[unit][2];
    if (n1 > 1 && n1 < 5) return forms[unit][1];
    if (n1 === 1) return forms[unit][0];
    return forms[unit][2];
  };

  const getDayForm = (days) => {
    return days === 1 ? '1д назад' : `${days}${getUnitForm(days, 'день').charAt(0)} назад`;
  };

  return {
    formatTimeAgo
  };
}